module.exports = __webpack_public_path__ + "static/media/co-owner-user.cb688cae.png";